import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = [{
    title: 'Búsquedas interminables',
    description: 'Horas perdidas entre capturas de pantalla, links rotos y patrones mal explicados que te hacen perder la paciencia.'
  }, {
    title: 'Talles incorrectos',
    description: 'Patrones que no encajan en talles reales o que no siguen las tendencias actuales, resultando en prendas que no usás.'
  }, {
    title: 'Proyectos a medias',
    description: 'Proyectos abandonados por falta de materiales adecuados o guías claras que te dejen avanzar con seguridad.'
  }, {
    title: 'Proveedores desconocidos',
    description: 'Frustración al no encontrar proveedores confiables en Uruguay para conseguir los materiales exactos.'
  }];
  return <section className="py-10 md:py-20 bg-[#F5EBE0] pt-[0px] pb-[0px]" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-171">
          <h2 className="text-2xl md:text-4xl font-bold text-[#3D2B1F] mb-3" data-id="element-172">
            ¿Te sentís identificada con esto?
          </h2>
          <p className="text-[#6B5A4E] text-base md:text-lg" data-id="element-173">
            Sabemos lo frustrante que puede ser querer tejer algo hermoso y
            encontrarse con obstáculos en cada paso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8" data-id="element-174">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#FAF7F4] p-4 md:p-6 rounded-xl border border-[#E6D5C8]" data-id="element-175">
              <div className="w-10 h-10 rounded-full bg-[#FCE8E8] flex items-center justify-center mb-3 text-[#D45D5D]" data-id="element-176">
                <XCircle className="w-5 h-5" data-id="element-177" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-[#3D2B1F] mb-2" data-id="element-178">
                {pain.title}
              </h3>
              <p className="text-sm md:text-base text-[#6B5A4E] leading-relaxed" data-id="element-179">
                {pain.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}